import { KitchenNews } from "../../../weekMenuTypes"
import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"
import { DynamicHtml } from "../../../../../../../shared/components/dynamic/DynamicHtml"
import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"
import { tailwindPalette } from "../../../../../../theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    contentContainer: {
        marginTop: "1rem",
        display: "flex",
        justifyContent: "center",
        overflowY: "auto",
    },
    content: {
        width: "100%",
        maxWidth: "50rem",
        margin: "0 auto",
        background: "white",
        padding: "3rem",
    },
    dialogPaper: {
        background: tailwindPalette.slate[100],
    },
    imageContainer: {
        overflow: "hidden",
        position: "relative",
        height: "20rem",
    },
    image: {
        objectFit: "cover",
        height: "100%",
        width: "100%",
    },
    subject: {
        margin: ".75rem 0",
    },
    body: {
        margin: "2rem 0",
    },
}))

type NewsModalProps = {
    isOpen: boolean
    onClose: () => void
    news?: KitchenNews | null
}

export function NewsModal({ isOpen, onClose, news }: NewsModalProps) {
    const { classes } = useStyles()

    if (!news) return null

    return (
        <StandardDialog
            slotProps={{ paper: { className: classes.dialogPaper } }}
            isFullScreen
            open={isOpen}
            onClose={onClose}
        >
            <Box className={classes.contentContainer}>
                <Box className={classes.content}>
                    {news.imageUrl && (
                        <Box className={classes.imageContainer}>
                            <img
                                src={news.imageUrl}
                                alt={news.subject}
                                title={news.subject}
                                className={classes.image}
                            />
                        </Box>
                    )}
                    <Typography variant="h5" className={classes.subject}>
                        {news.subject}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        {news.displayPublishDate}
                    </Typography>
                    <DynamicHtml html={news.body} className={classes.body} />
                </Box>
            </Box>
        </StandardDialog>
    )
}
